import calculateTimeDifference from "./calculateTimeDifference";
import { remaining } from "./locales";
var remainingTime = function remainingTime(date, lang) {
  var langKey = lang;
  return calculateTimeDifference(date, remaining[langKey]);
};
export default remainingTime;